import script from "./GroupEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupEdit.vue?vue&type=script&setup=true&lang=js"

import "./GroupEdit.vue?vue&type=style&index=0&id=d9e49aae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9e49aae"]])

export default __exports__